import { HttpService } from '../main/HttpService.js';

/*# This class' sole purpose is to communicate with the server. #*/
export class LinkBusinessMdlService extends HttpService {
  constructor(serviceUrl) {
    super(serviceUrl);
    //this.sameSiteOnly = true; // See super() for info
  }

  async getRetailers(searchType, key, maxDistance, signal) {
    return await this.fetchJson(`retailers?searchType=${searchType}&key=${key}&maxDistance=${maxDistance}`, { signal });
  }
}
